export const timestamps = [
  {name: 'created_at', type: 'number'},
  {name: 'created_by', type: 'string'},
  {name: 'updated_at', type: 'number'},
  {name: 'updated_by', type: 'string'},
  {name: 'deleted_at', type: 'number', isOptional: true},
  {name: 'deleted_by', type: 'string', isOptional: true},
];
